import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

export default new Router({
  routes: [
    // {
    //   path: '/',
    //   name: 'login',
    //   component: () => import('@/views/login'),
    // },
    {
      path: "/",
      name: "adminlogin",
      component: () => import("@/views/login")
    },
    {
      path: "/engineer",
      name: "engineer",
      component: () => import("@/views/engineer_home")
    },
    {
      path: "/engCost",
      name: "eng_cost",
      component: () => import("@/views/eng_cost_form")
    },
    {
      path: "/manager",
      name: "manager",
      component: () => import("@/views/manager_home")
    },
    {
      path: "/administrator",
      name: "administrator",
      component: () => import("@/views/administrator_home")
    },
    {
      path: "/super",
      name: "superadmin",
      component: () => import("@/views/super_admin")
    },
    {
      path: "/home",
      name: "home",
      component: () => import("@/views/home")
    },
    {
      path: "/instructions",
      name: "instructions",
      component: () => import("@/views/instructions"),
      children: [
        {
          path: "",
          redirect: "all"
        },
        {
          path: "all",
          component: () => import("@/components/Introduction/all")
        },
        {
          path: "overview",
          component: () => import("@/components/Introduction/overview")
        }
      ]
    },
    {
      path: "/experiment",
      name: "experiment",
      component: () => import("@/views/experiment_home"),
      children: [
        {
          path: "",
          redirect: "preprocessing"
        },
        {
          path: "preprocessing",
          component: () => import("@/views/preprocessing")
        },
        {
          path: "library_construction",
          component: () => import("@/views/library_construction")
        },
        {
          path: "library_vis",
          component: () => import("@/views/library_vis")
        },
        {
          path: "lab_manager",
          component: () => import("@/components/lab_manager")
        },
        {
          path: "vis_lab_manager",
          component: () => import("@/components/vis_lab_manager")
        },
        {
          path: "exeriment_admin",
          component: () => import("@/components/exeriment_admin")
        },
        {
          path: "collect",
          component: () => import("@/components/collect")
        },
        {
          path: "collect_vis",
          component: () => import("@/components/vis_collect")
        },
        {
          path: "collect_vis_terminal",
          component: () => import("@/components/vis_collect_terminal")
        },
        {
          path: "cost_check",
          component: () => import("@/views/cost_check")
        },
        {
          path: "collect_cost",
          component: () => import("@/views/collect_cost")
        }
      ]
    },
    {
      path: "/downloadUpload",
      name: "download_upload",
      component: () => import("@/views/download_upload")
    },
    {
      path: "/module",
      name: "module",
      component: () => import("@/views/module_home")
    },
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js